import React from 'react';
import PropTypes from 'prop-types';
import {
  IonModal,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonButton,
  IonText,
  IonImg,
} from '@ionic/react';
import storage from 'utils/storage';

function BleScanTipModal({ isOpen, setLoyaltyTypeModal }) {
  const onDoneAction = async () => {
    await storage.setItem('PREP_CAN_BLE_TIP', 'true');
    setLoyaltyTypeModal(null);
  }

  return (
    <IonModal isOpen={isOpen} className="custom-ble-alert-medium">
      <IonContent>
        <IonList>
          <IonItem lines="none" className="mt-3x mb">
            <div className="d-flex-content d-flex-center">
              <IonImg src="/assets/ble-scan-icon.png" className="ble-scan-icon-medium" />
            </div>
          </IonItem>

          <IonItem lines="none">
            <div className="d-flex-content d-flex-center">
              <IonLabel className="ion-text-wrap">
                <h3>Tap to pay available here</h3>
              </IonLabel>
            </div>
          </IonItem>

          <IonItem lines="none">
            <div className="d-flex-content d-flex-center">
              <IonLabel className="ion-text-wrap">
                <p className="custom-alert-message">This location allows you to tab your phone when you order to quickly look up your tab.</p>
              </IonLabel>

              <IonLabel className="ion-text-wrap mt">
                <p className="custom-alert-message">When ordering, click the "tap to pay"icon on the top right and hold your phone to the reader.</p>
              </IonLabel>
            </div>
          </IonItem>

          <IonItem lines="none" className="mt-5x">
            <div className="d-flex-row-center">
              <IonButton
                color="tertiary"
                expand="block"
                fill="solid"
                type="button"
                onClick={onDoneAction}
                className="loyalty-button-wrap mr-1"
              >
                <IonText color="light"><p className="loyalty-button-size">GOT IT</p></IonText>
              </IonButton>
            </div>
          </IonItem>
        </IonList>
      </IonContent>
    </IonModal>
  );
}

BleScanTipModal.propTypes = {
  isOpen: PropTypes.bool,
  setLoyaltyTypeModal: PropTypes.func,
};

export default BleScanTipModal;
